module.exports = __webpack_public_path__ + "img/taoyuan-6.b5d147a8.jpg";